/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable prettier/prettier */
import React, { useState } from 'react'

import { Redirect } from 'react-router-dom'

import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import Link2 from '@material-ui/core/Link'
import InputLabel from '@material-ui/core/InputLabel'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined'
import Grid from '@material-ui/core/Grid'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import LinearProgress from '../../elements-ui/LinearProgress/index'

import axios from 'axios'

import { Container, Card, CardContent, LoadingArea, Logo, Title, Description, Copyright, Symbol } from './styles'

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {

    const [logado, setLogado] = useState(false)
    const [loading, setLoading] = useState(false)

    const [errorEmail, setErrorEmail] = useState(false)
    const [errorEmailHelper, setErrorEmailHelper] = useState('')
    const [email, setEmail] = useState()

    const [errorSenha, setErrorSenha] = useState(false)
    const [errorSenhaHelper, setErrorSenhaHelper] = useState('')
    const [senha, setSenha] = useState()

    const [values, setValues] = useState({
        password: '',
        showPassword: false,
    })

    const [checkbox, setCheckbox] = React.useState({
        checked: true
    })

    const anoCorrente = new Date().getFullYear()

    const handleChange = prop => event => {
        setValues({
            ...values, [prop]: event.target.value
        },
        {
            ...values, [prop]: setSenha(event.target.value)
        })
    }

    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword })
    }

    const handleMouseDownPassword = event => {
        event.preventDefault();
    }

    const handleCheckbox = name => event => {
        setCheckbox({ ...checkbox, [name]: event.target.checked })
    }

    const handleKeyDown = event => {
        if (event.key === 'Enter') {
            handleSubmit()
        }
    }

    function validaForm() {
        if (!email) {
            setErrorEmail(true)
            setErrorEmailHelper("O usuário não pode ficar em branco")
            return false
        }

        if (!senha) {
            setErrorSenha(true)
            setErrorSenhaHelper("A senha não pode ficar em branco")
            return false
        }

        return( true )
    }

    async function handleSubmit() {
        if (email) {
            setErrorEmail(false)
            setErrorEmailHelper("")
        }

        if (senha) {
            setErrorSenha(false)
            setErrorSenhaHelper("")
        }

        if (validaForm()) {

            setLoading(true)

            await axios.post(`${props.urlLogin}/api/v1/Autenticacao`, {
                usuario: email,
                senha: senha,
                tipoUsuario: 0
            })
            .then(function(response) {
                //Salva JWT no localStorage
                localStorage.setItem(`@${props.nomeSistema}`, response.data.accessToken)

                //Salva os dados de usuario no localStorage
                localStorage.setItem(`@${props.nomeSistema}-data`, JSON.stringify({
                    id: response.data.id,
                    nome: response.data.nome, 
                    email: response.data.email,
                    setor: response.data.nomeSetor,
                    usuario: email
                }))

                //Remove o login e rediciona para a home page
                setLoading(false)
                setLogado(true)
            })
            .catch(function(error) {
                setLoading(false)
                switch (error) {
                    case 'Request failed with status code 422':
                        setErrorEmail(true)
                        setErrorEmailHelper("O usuário está incorreto")
                        setErrorSenha(true)
                        setErrorSenhaHelper("A senha está incorreta")
                        break
                    default:
                        setErrorEmail(true)
                        setErrorEmailHelper("O usuário está incorreto")
                        setErrorSenha(true)
                        setErrorSenhaHelper("A senha está incorreta")
                        break
                }
            })
        }
    }

    return (
        <Container>
            <Card>

                {
                    logado ? <Redirect to="/Home" /> : null
                }

                {
                    loading 
                    ?
                        <LoadingArea>
                            <LinearProgress />
                        </LoadingArea>
                    :   
                        null
                }

                <CardContent>
                    <Logo src={props.imgLogo} />
                    <Title>{props.nomeProjeto}</Title>
                    <Description>Tribunal de Contas do Estado de Goiás</Description>

                    <FormControl className="FormControl" variant="outlined">
                        <OutlinedInput
                            id="outlined-adornment-usuario"
                            autoFocus={false}
                            onChange={(e) => setEmail(e.target.value) }
                            onKeyPress={handleKeyDown}
                            startAdornment={
                            <InputAdornment position="start">
                                <AccountCircleOutlinedIcon className="iconLogin" />
                            </InputAdornment>
                            }
                            labelWidth={70}
                            error={errorEmail}
                        />
                        <InputLabel htmlFor="outlined-adornment-usuario">Usuário</InputLabel>
                        {
                            errorEmail ?
                            <Typography variant="caption" display="block" gutterBottom className="errorEmailHelper">
                                {errorEmailHelper}
                            </Typography>
                            :
                            null
                        }
                    </FormControl>

                    <FormControl className="FormControl" variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-senha">Senha</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-senha"
                            type={values.showPassword ? 'text' : 'password'}
                            value={values.password}
                            onChange={handleChange('password')}
                            onKeyPress={handleKeyDown}
                            endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                                >
                                {values.showPassword ? <Visibility className="iconLogin"/> : <VisibilityOff className="iconLogin"/>}
                                </IconButton>
                            </InputAdornment>
                            }
                            labelWidth={70}
                            error={errorSenha}
                        />

                        {
                            errorSenha ?
                            <span className="MuiTypography-root makeStyles-errorEmailHelper-17 MuiTypography-caption MuiTypography-gutterBottom MuiTypography-displayBlock errorSenha">{errorSenhaHelper}</span>
                            :
                            null
                        }
                    </FormControl>

                    <Grid container spacing={3} className="recuperarSenha">
                        <Grid item xs={6}>
                            <FormControlLabel
                                className="checkbox"
                                control={
                                    <Checkbox
                                        checked={checkbox.checked}
                                        onChange={handleCheckbox('checked')}
                                        value="checked"
                                        color="primary"
                                    />
                                }
                                label="Lembrar senha"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Typography className="root">
                                <Link2 href="#" className="link">
                                    Esqueceu sua senha?
                                </Link2>
                            </Typography>
                        </Grid>
                    </Grid>
                </CardContent>

                <CardContent >
                    <Grid container spacing={3}>
                        <Grid item xs={12} align="right">
                            <Button variant="contained" className="button-tce" onClick={handleSubmit}>
                                Entrar
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
                
                <Copyright>
                    {anoCorrente} <Symbol>©</Symbol> Tribunal de Contas do Estado de Goiás
                </Copyright>
            </Card>
        </Container>
    )
}